import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { createAxiosResponseInterceptor } from "../../api/interceptor";
import {
  getMuhuratRequest,
  getMuhuratSuccess,
  getMuhuratFailure,
  getInterestingFactsRequest,
  getInterestingFactsSuccess,
  getInterestingFactsFailure,
} from "./muhuratSlice";

createAxiosResponseInterceptor();

function* getMuhuratWorker() {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/muhurt`
    );

    yield put(getMuhuratSuccess(response.data));
  } catch (error) {
    yield put(
      getMuhuratFailure(
        error.response?.data?.message || error.message || "Unauthorized"
      )
    );
  }
}

function* getInterestingFactsWorker() {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/interesting-facts/mobile`
    );

    yield put(getInterestingFactsSuccess(response.data));
  } catch (error) {
    yield put(
      getInterestingFactsFailure(
        error.response?.data?.message ||
          error.message ||
          "Unable to load interesting facts."
      )
    );
  }
}

export function* muhuratSaga() {
  yield takeLatest(getMuhuratRequest.type, getMuhuratWorker);
  yield takeLatest(getInterestingFactsRequest.type, getInterestingFactsWorker);
}
